/**
 * Permission keys — a mirror of the backend's catalog (`src/modules/auth/permissions.ts` in
 * club29-saas-backend). The backend is the source of truth: add a key there first.
 *
 * The UI shows or hides screens and buttons by permission, never by role name — admins create
 * their own roles. The API enforces every permission regardless of what the UI shows.
 */
export const PERMISSIONS = {
  USERS_MANAGE: 'users:manage',
  ROLES_MANAGE: 'roles:manage',
  PACKAGES_READ: 'packages:read',
  PACKAGES_WRITE: 'packages:write',
  PROSPECTS_READ: 'prospects:read',
  PROSPECTS_WRITE: 'prospects:write',
  MEMBERS_READ: 'members:read',
  MEMBERS_WRITE: 'members:write',
  MEMBER_ACCOUNTS_MANAGE: 'member-accounts:manage',
  MEMBERSHIPS_READ: 'memberships:read',
  MEMBERSHIPS_WRITE: 'memberships:write',
  INVOICES_READ: 'invoices:read',
  PAYMENTS_WRITE: 'payments:write',
  PT_SALES_READ: 'pt-sales:read',
  PT_SALES_WRITE: 'pt-sales:write',
  ATTENDANCE_READ: 'attendance:read',
  ATTENDANCE_MANAGE: 'attendance:manage',
  /** Member logins only — used by the mobile app; the website turns member logins away. */
  SELF_READ: 'self:read',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
